import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers/reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const channelSettingsSlice = createAppSlice({
  name: 'channelSettings',
  initialState,
  reducers,
});

export const {
  createRedirect,
  updateRedirect,
  deleteRedirect,
  setShowRedirectModal,
  updateProjectAlertEmails,
  getBccEmails,
  getRedirects,
  getProjectAlertEmails,
  setShowEditChannelDetailsModal,
  setShowEditPrimaryContactModal,
  setShowEditEmailSettingsModal,
  updateBccEmails,
  getApiKeys,
  createApiKey,
  deactivateApiKey,
  fetchChannelInstances,
  fetchTrayUser,
  fetchSolutions,
  fetchSolutionInstances,
  toggleSolutionInstance,
  createSolutionInstance,
  fetchOauthIntegration,
  toggleOAuthIntegrationAdminUse,
  toggleOAuthIntegration,
  createOAuthIntegration,
  updateOAuthIntegration,
  clearInstanceToCreate,
  setStripeContact,
  fetchStripeIntegration,
  setShowStripeModal,
  setShowUpsertIntegrationModal,
  setShowSelectIntegrationModal,
  setIntegrationNameToAdd,
  setShowHiveModal,
  setShowKollectiveModal,
  setInboundIntegrationToEdit,
} = channelSettingsSlice.actions;

export default channelSettingsSlice.reducer;
